(function checkboxPlugin(global) {
  "use strict";

  /**
  * Плагин для колонки таблицы с флажком.
  *
  * @class WebAccess.components.dataViews.gridPlugins.CheckboxPlugin
  * @extends WebAccess.Plugin
  * @property {string} name Имя плагина.  
  * @since 5.2.0.1100
  */
  global.CheckboxPlugin = WA.Plugin.extend({    
    name: 'CheckboxPlugin',

    // Грид. 
    _grid: null,
    // Стандартный плагин для чекбоксов.
    _checkboxSelector: null,

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.CheckboxPlugin#register
    * @param {WebAccess.components.dataViews.Grid} Таблица
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.     
    */
    register: function (grid) {
      var me = this;
      me._grid = grid;
 

      me._checkboxSelector = new Slick.CheckboxSelectColumn({
        columnId: '_Checkbox',
        cssClass: 'slick-cell-checkboxsel',
        toolTip: L('SELECT_ALL'),
        headerCssClass: 'centered notDraggable',
        width: 30
      });

      me._grid.bind(WA.CMP.DV.Grid.EVENT.BEFORE_GRID_INIT, $.proxy(me._onGridBeforeInit, me));
      me._grid.bind(WA.CMP.DV.Grid.EVENT.GRID_INIT, $.proxy(me._onGridInit, me));
      return {};
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Хэндлер события до инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.CheckboxPlugin#_onGridBeforeInit
    * @param {string} containerSelector селектор контейнера для грида.
    * @param {Object} dataView представление данных.
    * @param {Object} columns описания всех колонок.
    * @param {Object} settings настройки грида.
    * @private
    * @since 5.2.0.1100
    */
    _onGridBeforeInit: function (containerSelector, dataView, columns, settings) {      
      var me = this;
      var checkboxColumndDef = this._checkboxSelector.getColumnDefinition();
      var column = _.findWhere(columns, { id: checkboxColumndDef.id });
      $.extend(column, checkboxColumndDef);
      
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработчик события инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.CheckboxPlugin#_onGridInit
    * @private
    * @since 5.2.0.1100
    */
    _onGridInit: function () {
      var me = this;
      this._grid.grid.setSelectionModel(new Slick.RowSelectionModel({ selectActiveRow: false }));
      this._grid.grid.registerPlugin(this._checkboxSelector);

      this._grid.dataView.syncGridSelection(me._grid.grid, true);

      // Для работы objectList.
      me._grid.grid.onSelectedRowsChanged.subscribe(function (e, args) {     
        me._grid.fire(WA.CMP.DV.Grid.EVENT.SELECTED_ROWS_CHANGED);
      });

      // Пометка галочкой строки по клику на свободное место.
      me._grid.grid.onClick.subscribe(function (e, args) {
        
        // Для строк без данных не выделяем.
        if (me._grid.dataView.getItem(args.row).__nonDataRow) return;        

        me._grid.grid.getSelectionModel().selectOnClickEvent(e, true);
        // вызываем событие изменения checkbox-а для работы клиентской ОМ
        var el = $(e.target).parents('.List:first').find("input.chk");
        el.trigger('itemChecked', []);
      });
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

})(WA.components.dataViews.gridPlugins);